import { ReactNode, createContext, useContext } from 'react';

export enum Page {
  PATIENT_FORM = 'PATIENT_FORM',
  INFO = 'INFO',
  PRODUCT_LIST = 'PRODUCT_LIST',
  PRODUCT_SLOTS = 'PRODUCT_SLOTS',
  UPLOAD = 'UPLOAD',
  APPOINTMENT_CONFIRMATION = 'APPOINTMENT_CONFIRMATION',
  CONCLUSION = 'CONCLUSION'
}

type RouterHistory = {
  index: number;
  page: Page;
  component: ReactNode;
  params: Record<string, unknown>;
  title: string;
  nextPage: string;
};

export interface ICheckUpRouterContext {
  navigate: (page: Page, params?: Record<string, unknown>) => void;
  goBack: (props?: { page?: keyof typeof Page }) => void;
  history: RouterHistory[];
}

export const CheckUpRouterContext = createContext<ICheckUpRouterContext>({
  navigate: () => void 0,
  goBack: () => void 0,
  history: []
});

export function useCheckUpRouter() {
  return useContext(CheckUpRouterContext);
}
